import React from 'react'

export const LogoWidget = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        fontSize: 20,
        fontWeight: 400,
      }}
    >
      {/* <span> (no default <p> margins) + full height so it centers vertically */}
      <span style={{ margin: 0, lineHeight: 1 }}>Form Designer</span>
    </div>
  )
}
